import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {UniversityStatService} from '../../../shared/services/university-stat.service';
import {UniversityService} from '../../../shared/services/university.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-university-stat',
    templateUrl: './university-stat.component.html',
    styleUrls: ['./university-stat.component.scss']
})
export class UniversityStatComponent implements OnInit {
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    @Input() universityId: any;
    @Output() saved = new EventEmitter<void>();
    submitting: any = false;
    dataExists: any = false;
    university: any;
    data: any = {
        rating: '',
        review_count: '',
        placement_score: '',
        average_salary: '',
        highest_package: '',
        recruiters_count: '',
        placement_rate: '',
        scholarship: '',
        annual_fees: '',
        emi_starting: '',
        ai_summary: '',
        ai_recommended: false
    };

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityStatService: UniversityStatService,
                private universityService: UniversityService,
                private alertService: AlertService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        if (!this.universityId) {
            this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        }
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
        this.universityStatService.detailByAdmin(this.universityId).subscribe(data => {
            if (data) {
                this.data = {
                    rating: data['rating'] || '',
                    review_count: data['review_count'] || '',
                    placement_score: data['placement_score'] || '',
                    average_salary: data['average_salary'] || '',
                    highest_package: data['highest_package'] || '',
                    recruiters_count: data['recruiters_count'] || '',
                    placement_rate: data['placement_rate'] || '',
                    scholarship: data['scholarship'] || '',
                    annual_fees: data['annual_fees'] || '',
                    emi_starting: data['emi_starting'] || '',
                    ai_summary: data['ai_summary'] || '',
                    ai_recommended: !!data['ai_recommended']
                };
                this.dataExists = true;
            } else {
                this.dataExists = false;
            }
        });
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
            }
        });
    }

    submit() {
        this.submitting = true;
        if (this.dataExists) {
            this.universityStatService.updateByAdmin(this.universityId, this.data).subscribe(data => {
                this.submitting = false;
                this.alertService.showSuccess({title: 'Success', message: 'Card Stats updated successfully'});
                this.saved.emit();
            }, error => {
                this.submitting = false;
            });
        } else {
            this.universityStatService.createByAdmin(this.universityId, this.data).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
                this.alertService.showSuccess({title: 'Success', message: 'Card Stats saved successfully'});
                this.saved.emit();
            }, error => {
                this.submitting = false;
            });
        }
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
